/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// utils
import { fetchProductDataLastUpdated } from '../../../../state/thunks/product';
import { APIStringtoDate } from '../../../../utils/date';
import { getDevices } from '../../../../utils/filterhelpers';
// material
import { Page, Content, InContentMessage} from '@insticator/insticator-ui';
import Header from '../../../../material/structure/header/header';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import GlobalFilter from '../../../../material/globalfilter/globalfilter';
// styles
import injectSheet from 'react-jss';
import styles from './articlesentimentv2analytics_styles';
import Space from 'material/space/space';
// components
import TotalClicksReport from './totalclicksreport/totalclicksreports';
import TopArticlesReport from './toparticlesreport/toparticlesreport';
import InviewEmbedLoadsReport from './inviewembedloadsreport/inviewembedloadsreport';
import { fetchInViewRateReport, fetchPopularArticlesReport, fetchReactionClickRateReport, fetchReactionClicksReport, fetchTotalEmbedLoadsReport } from 'state/thunks/articlesentimentv2';




/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT V2 - ANALYTICS PAGE ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
    // state
    const { accountUUID, siteUUID } = useSelector((state) => state.session);
    const { sites, dateRange, devices, compareTo, countries } = useSelector((state) => state.app.filters);
    const { lastUpdated } = useSelector(state => state.articleSentimentV2);
    const [selectedInterval, setSelectedInterval] = useState('daily');
    const [selectedMetric, selectMetric] = useState('total')
    // actions
    const dispatch = useDispatch();

    // request reports on division load
    useEffect(() => {
        sendReportRequests()
    }, [sites, devices, compareTo, countries,selectedInterval]);

    // request top articles on change of selected metric
    useEffect(() => {
        getPopularArticlesReport()
    }, [selectedMetric])

    const sendReportRequests = () => {
        getReactionClicksReport()
        getReactionClickRateReport()
        getPopularArticlesReport()
        getInViewRateReport()
        getEmbedLoadsReport()
        getProductDataLastUpdated()
    }

    const getProductDataLastUpdated = () => dispatch(fetchProductDataLastUpdated('ARTICLE_SENTIMENT'));
    
    const getReactionClicksReport = () => dispatch(fetchReactionClicksReport({requestData: getRequestData()}))

    const getReactionClickRateReport = () => dispatch(fetchReactionClickRateReport({requestData: getRequestData()}))

    const getInViewRateReport = () => dispatch(fetchInViewRateReport({requestData: getRequestData()}))

    const getEmbedLoadsReport = () => dispatch(fetchTotalEmbedLoadsReport({requestData: getRequestData()}))

    const getPopularArticlesReport = () => dispatch(
        fetchPopularArticlesReport({
            requestData: topArticlesRequestData
        }
    ));


    const getRequestData = () => ({
        accountUUID,
        sites: sites,
        startDate: dateRange.from,
        endDate: dateRange.to,
        devices: getDevices(devices, 'article_sentiment'),
        granularity: selectedInterval.toUpperCase(),
        comparisonType: compareTo,
        countries: countries.length === 250 ? [] : countries
    });

    const topArticlesRequestData = {
        ...getRequestData(),
        emoji: selectedMetric,
        isAscendingOrder: false
    }

    const getBannerText = useCallback(() => {
        // if start date is before June 21st 2021
        const june21stDate = new Date(2021, 5, 21)
         if (dateRange.from && APIStringtoDate(dateRange.from) < june21stDate){
             return 'There is no commenting data prior to June 21st, 2021';
         }
         return null;
    }, [dateRange]);

    return (
        <Page name={'articlesentimentv2analyticspage'} klass={`${props.classes.articlesentimentv2analyticspage}`} >
            <Header>
                <GlobalFilter onFilterApply={sendReportRequests}/>
            </Header>
            <Content>
                <InContentMessage/>
                <PageHeader
                    lastUpdatedTimestamp={lastUpdated}
                    title={'Article Sentiment'}
                    subtitle={'Analytics'}
                    dataTip={true}
                    bannerText={getBannerText()} />
                <PageContent>
                    <Space gap={24} direction={'column'}>
                        <TotalClicksReport selectedInterval={selectedInterval} setSelectedInterval={setSelectedInterval} />
                        <TopArticlesReport 
                            selectMetric={selectMetric} 
                            selectedMetric={selectedMetric} 
                            requestData={topArticlesRequestData}
                            selectedInterval={selectedInterval} 
                            setSelectedInterval={setSelectedInterval}  
                        />
                        <InviewEmbedLoadsReport selectedInterval={selectedInterval} setSelectedInterval={setSelectedInterval}  />
                    </Space>
                </PageContent>
            </Content>
        </Page>
    );
});
